import { fork, put, takeLatest } from 'redux-saga/effects';
import { getType } from '../../utils';
import actions from './actions';
export function* loadUserInfo(api, action) {
    const { userId, clientId, withGroup = false } = action.payload;
    try {
        const user = yield api
            .getUser({
            id: userId,
            clientId,
            withGroup,
        })
            .then((p) => p.request);
        yield put(actions.loadUserInfoSuccess(user));
    }
    catch (error) {
        yield put(actions.loadUserInfoError(error));
    }
}
export function* editUserInfo(api, action) {
    const { userId, clientId, profile } = action.payload;
    try {
        yield api
            .editUserProfile({
            id: userId,
            clientId,
            profile,
        })
            .then((p) => p.request);
        yield put(actions.editUserInfoSuccess(userId));
    }
    catch (error) {
        yield put(actions.editUserInfoError(error));
    }
}
export function* editUserClient(api, action) {
    const { userId, clientId, settings, metadata } = action.payload;
    try {
        yield api
            .editUserClient({
            id: userId,
            clientId,
            settings,
            metadata,
        })
            .then((p) => p.request);
        yield put(actions.editUserClientSuccess());
    }
    catch (error) {
        yield put(actions.editUserClientError(error));
    }
}
export function* deleteUserInfoGroup(api, action) {
    const { userId, groupId, clientId } = action.payload;
    try {
        yield api
            .deleteUserGroup({
            userId,
            groupId,
            clientId,
        })
            .then((p) => p.request);
        yield put(actions.deleteUserInfoGroupSuccess(groupId));
    }
    catch (error) {
        yield put(actions.deleteUserInfoGroupError(error));
    }
}
export function* deleteUserInfoClient(api, action) {
    const { userId, clientId } = action.payload;
    try {
        yield api
            .deleteUserClient({
            userId,
            clientId,
        })
            .then((p) => p.request);
        yield put(actions.deleteUserInfoClientSuccess(clientId));
    }
    catch (error) {
        yield put(actions.deleteUserInfoClientError(error));
    }
}
export function* deleteUser(api, action) {
    const { userId } = action.payload;
    try {
        yield api.deleteUser(userId).then((p) => p.request);
        yield put(actions.deleteUserSuccess(userId));
    }
    catch (error) {
        yield put(actions.deleteUserError(error));
    }
}
export function* watchLoadUserInfo(api) {
    yield takeLatest(getType(actions.loadUserInfo), loadUserInfo, api);
}
export function* watchEditUserInfo(api) {
    yield takeLatest(getType(actions.editUserInfo), editUserInfo, api);
}
export function* watchEditUserClient(api) {
    yield takeLatest(getType(actions.editUserClient), editUserClient, api);
}
export function* watchDeleteUserInfoGroup(api) {
    yield takeLatest(getType(actions.deleteUserInfoGroup), deleteUserInfoGroup, api);
}
export function* watchDeleteUserInfoClient(api) {
    yield takeLatest(getType(actions.deleteUserInfoClient), deleteUserInfoClient, api);
}
export function* watchDeleteUser(api) {
    yield takeLatest(getType(actions.deleteUser), deleteUser, api);
}
export const userSagas = (api) => [
    fork(watchLoadUserInfo, api),
    fork(watchEditUserInfo, api),
    fork(watchEditUserClient, api),
    fork(watchDeleteUserInfoGroup, api),
    fork(watchDeleteUserInfoClient, api),
    fork(watchDeleteUser, api),
];
export default userSagas;
